// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pagination {
    display: flex;
    justify-content: space-between;
}

.pagination>p {
    font-size: 14px;
    font-weight: 500;
}

.paginationbtns {
    display: flex;
    justify-content: flex-end;
    gap: 10px
}

.pagination_button {
    padding: 5px;
    background-color: #e9e9e9;
    border: 1px solid #ddd;
    color: black;
    cursor: pointer;
    transition: background-color 0.3s ease;
    border-radius: 5px;
}

.pagination_button:disabled {
    cursor: not-allowed;
    color: rgba(0, 0, 0, 0.514)
}

.pagination_activebutton {
    padding: 8px 12px;
    width: 35px;
    height: 35px;
    background: linear-gradient(to right, #111f42, #2672fb);
    /* background: linear-gradient(90deg, rgba(60, 60, 119) 40%, #9a36e1e1 100%); */
    border-radius: 5px;
    color: white;
    cursor: pointer;
    border: none;
    transition: background-color 0.3s ease;
    box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.26);
}`, "",{"version":3,"sources":["webpack://./src/components/Pagination/Pagination.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB;AACJ;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,sBAAsB;IACtB,YAAY;IACZ,eAAe;IACf,sCAAsC;IACtC,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,uDAAuD;IACvD,+EAA+E;IAC/E,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,sCAAsC;IACtC,2CAA2C;AAC/C","sourcesContent":[".pagination {\n    display: flex;\n    justify-content: space-between;\n}\n\n.pagination>p {\n    font-size: 14px;\n    font-weight: 500;\n}\n\n.paginationbtns {\n    display: flex;\n    justify-content: flex-end;\n    gap: 10px\n}\n\n.pagination_button {\n    padding: 5px;\n    background-color: #e9e9e9;\n    border: 1px solid #ddd;\n    color: black;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n    border-radius: 5px;\n}\n\n.pagination_button:disabled {\n    cursor: not-allowed;\n    color: rgba(0, 0, 0, 0.514)\n}\n\n.pagination_activebutton {\n    padding: 8px 12px;\n    width: 35px;\n    height: 35px;\n    background: linear-gradient(to right, #111f42, #2672fb);\n    /* background: linear-gradient(90deg, rgba(60, 60, 119) 40%, #9a36e1e1 100%); */\n    border-radius: 5px;\n    color: white;\n    cursor: pointer;\n    border: none;\n    transition: background-color 0.3s ease;\n    box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.26);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
